import React, { createContext, useContext, useState } from 'react';

const ChatbotContext = createContext();

export const useChatbot = () => {
  const context = useContext(ChatbotContext);
  if (!context) {
    throw new Error('useChatbot must be used within a ChatbotProvider');
  }
  return context;
};

export const ChatbotProvider = ({ children }) => {
  const [isAdminChatbotEnabled, setIsAdminChatbotEnabled] = useState(true);

  const toggleAdminChatbot = () => {
    setIsAdminChatbotEnabled(prev => !prev);
  };

  return (
    <ChatbotContext.Provider value={{ isAdminChatbotEnabled, toggleAdminChatbot }}>
      {children}
    </ChatbotContext.Provider>
  );
}; 